/* npm modules outside of vrbo */
import React from 'react';
import {PropTypes} from 'prop-types';

/* Atoms (custom) */
import {Typography} from '../../atoms/Typography/Typography';

/* Styles */
import './CardContent.less';

export const CardContent = ({cardHeading, children, subHeading}) => {
    return (
        <div className="CardContent">
            <Typography
                className="CardContent__heading"
                content={cardHeading}
                TagName="h3"
            />
            {subHeading && (
                <Typography
                    className="CardContent__subHeading text-default"
                    content={subHeading}
                    TagName="div"
                />
            )}
            {children}
        </div>
    );
};

CardContent.PropTypes = {
    cardHeading: PropTypes.string.isRequired,
    children: PropTypes.element,
    subHeading: PropTypes.string,
};
